import { ColorTag } from '@sprinklr/display-builder/widgets/utils/getColorTag';

type LegacyColorTag = {
    value: number | null | Duration;
    comparison: '>' | '<' | '===' | '>=' | '<=';
    color: string;
};
export function convertMetricDesignOptions(metricDesignOptions: {
    [key: string]: Record<string, any> & {
        colorTags: LegacyColorTag[];
    };
}): {
    [key: string]: Record<string, any> & {
        colorTags: ColorTag[];
    };
} {
    const newDesignOptions = JSON.parse(JSON.stringify(metricDesignOptions));

    // map over each metric
    Object.keys(newDesignOptions).forEach(key => {
        // if the metric has color tags
        if (newDesignOptions[key].colorTags?.length > 0) {
            // map over each color tag
            newDesignOptions[key].colorTags?.forEach(colorTag => {
                // if the color tag has no conditions, convert it to the new format
                if (!colorTag.conditions || colorTag.conditions?.length === 0) {
                    colorTag.conditions = [{ ...colorTag, name: key, type: 'METRIC' }];
                    delete colorTag.comparison;
                    delete colorTag.value;
                }
            });
            newDesignOptions[key].colorTags.reverse();
        }
    });

    return newDesignOptions;
}
